<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>    
  </div>
</template>

<script>
import SweetAlert from 'sweetalert2'
import api from '../api'

export default {
  name: 'App',
  data () {
    return {
      section: 'Head',
      guestActivityId: 0
    }
  },
  created () {
    // Listen to check-in-confirmation coming from SignalR events
    this.$clientHub.$on('check-in-confirmation', this.onCheckInConfirmation)
  },
  methods: {
    logout () {
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)

      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
      }

      this.$router.push('/login')
    },
    getImageUrl(imageUrl) {
      // return api.getBaseUrl('Guest', '/api/Guest/GetImage?Id=' + id)
      return api.getBaseUrl('Guest', '/image/Guest/' + imageUrl + '?' + Date.now())
    },
    // This is called from the server through SignalR
    onCheckInConfirmation ({ guest, projectId, guestActivityId, detailMessage }) {
      var guestName = []
      if (guest.firstName) {
        guestName.push(guest.firstName)
      }
      if (guest.lastName) {
        guestName.push(guest.lastName)
      }

      // let membershipStatus = guest.isMembershipActive ? 'Active' : 'Inactive'
      let membershipStatus = guest.membershipStatus
      let locationId = window.localStorage.getItem('locationId')

      if (guest.locationId === locationId) {
        if (guest.isMembershipActive) {
          // this.checkInConfirmation(guestActivityId)
          SweetAlert.fire({
            title: 'Please confirm this guest to do check-in process ?',
            html: '<h3 style="color:red; font-weight:bold;">' + guestName.join(' ') + '</h3> <br>' + '<img src="' + this.getImageUrl(guest.imageUrl) + '&' + Date.now() + '" class="img-responsive img-thumbnail" style="max-height:300px;max-width:300px;">' +
                  '<br> <h4 style="color:blue;">Membership: ' + guest.membershipName + '</h4>' +
                  '<br> <h3 style="color:red;margin:0px;">' + membershipStatus + '</h3>' +
                  '<br> <h5 style="color:red;margin:0px;">' + detailMessage + '</h5>',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            showCloseButton: true,
            showLoaderOnConfirm: true
          })
          .then((result) => {
            if (result.value) {
              this.checkInConfirmation(guestActivityId)
            } else if (result.dismiss === SweetAlert.DismissReason.cancel || result.dismiss === SweetAlert.DismissReason.backdrop) {
              SweetAlert.fire('Cancelled', 'The guest still not check-in', 'info')
            }
          })
        } else {
          SweetAlert.fire({
            title: 'Please confirm this guest to do check-in process ?',
            html: '<h3 style="color:red; font-weight:bold;">' + guestName.join(' ') + '</h3> <br>' + '<img src="' + this.getImageUrl(guest.imageUrl) + '&' + Date.now() + '" class="img-responsive img-thumbnail" style="max-height:300px;max-width:300px;">' +
                  '<br> <h4 style="color:blue;">Membership: ' + guest.membershipName + '</h4>' +
                  '<br> <h3 style="color:red;margin:0px;">' + membershipStatus + '</h3>' +
                  '<br> <h5 style="color:red;margin:0px;">' + detailMessage + '</h5>',
            type: 'warning',
            showCloseButton: true,
            showLoaderOnConfirm: true
          })
          .then((result) => {
            // if (result.value) {
            //   this.checkInConfirmation(guestActivityId)
            // } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
            //   SweetAlert.fire('Cancelled', 'The guest still not check-in', 'info')
            // }
          })
        }
      }
    },
    checkInConfirmation(guestActivityId) {
      var status = 'success'
      var message = ''
      var reqData = {
        Id: guestActivityId
      }
      api
        .request('Guest', 'post', '/api/Guest/CheckInConfirmation', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')

          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?1cec66bb